import { useCallback, useState } from 'react';
import { Option } from 'models/Global';
import mixpanelService from 'services/mixpanelService';
import useGetMixpanelProps from 'hooks/useGetMixpanelProps';
import { getMixpanelErrorProps } from 'axiosUtils';
import { ErrorViewedProps } from 'models/MixpanelEvents';

export default function useSearchableFilters(
  getOptionsOnSearch: (searchString: string) => Promise<Option[]>,
) {
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState<Option[]>([]);

  const getMixpanelProps = useGetMixpanelProps();

  const resetState = useCallback(() => {
    setIsLoading(false);
    setOptions([]);
  }, []);

  const onSearch = useCallback(
    async (searchString: string) => {
      if (!searchString) {
        resetState();
        return;
      }

      setIsLoading(true);

      try {
        const options = await getOptionsOnSearch(searchString);

        setOptions(options);
      } catch (e) {
        mixpanelService.errorViewed(
          getMixpanelProps(getMixpanelErrorProps(e)) as ErrorViewedProps,
        );
        setOptions([]);
      } finally {
        setIsLoading(false);
      }
    },
    [getOptionsOnSearch, getMixpanelProps, resetState],
  );

  return { isLoading, options, onSearch, resetState };
}
